module.exports = __webpack_public_path__ + "img/tabicon4.f569e145.png";